export default __webpack_public_path__ + "static/media/thumbnail1.49c95438.jpg";